module.exports = __webpack_public_path__ + "img/veusinho-okay.9a652c9a.png";